// Auto-generated by import-constants plugin. Do not edit manually.

export const optionalImportEntrypoints: string[] = [];
